import { ANNOUNCEMENTS_ACTIONS } from "../actions/announcements.actions";

interface PlatformNotification {
  uuid: string;
  textEn: string;
  textFr: string;
  type: 'upf_announcement';
  title?: string;
  isScheduled: boolean;
  scheduledStart?: string | null;
  scheduledEnd?: string | null;
  isActive: boolean;
}

interface AnnouncementsState {
  announcements: PlatformNotification[];
  loading: boolean;
  error: string | null;
  createLoading: boolean;
  updateLoading: boolean;
  deleteLoading: boolean;
  toggleLoading: boolean;
}

const initialState: AnnouncementsState = {
  announcements: [],
  loading: false,
  error: null,
  createLoading: false,
  updateLoading: false,
  deleteLoading: false,
  toggleLoading: false,
};

const announcementsReducer = (state = initialState, action: any): AnnouncementsState => {
  switch (action.type) {
    // Get Announcements
    case ANNOUNCEMENTS_ACTIONS.GET_ANNOUNCEMENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case ANNOUNCEMENTS_ACTIONS.GET_ANNOUNCEMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        announcements: action.payload,
        error: null,
      };

    case ANNOUNCEMENTS_ACTIONS.GET_ANNOUNCEMENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Create Announcement
    case ANNOUNCEMENTS_ACTIONS.CREATE_ANNOUNCEMENT_REQUEST:
      return {
        ...state,
        createLoading: true,
        error: null,
      };

    case ANNOUNCEMENTS_ACTIONS.CREATE_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        createLoading: false,
        announcements: action.payload,
        error: null,
      };

    case ANNOUNCEMENTS_ACTIONS.CREATE_ANNOUNCEMENT_FAILURE:
      return {
        ...state,
        createLoading: false,
        error: action.payload,
      };

    // Update Announcement
    case ANNOUNCEMENTS_ACTIONS.UPDATE_ANNOUNCEMENT_REQUEST:
      return {
        ...state,
        updateLoading: true,
        error: null,
      };

    case ANNOUNCEMENTS_ACTIONS.UPDATE_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        announcements: action.payload,
        error: null,
      };

    case ANNOUNCEMENTS_ACTIONS.UPDATE_ANNOUNCEMENT_FAILURE:
      return {
        ...state,
        updateLoading: false,
        error: action.payload,
      };

    // Delete Announcement
    case ANNOUNCEMENTS_ACTIONS.DELETE_ANNOUNCEMENT_REQUEST:
      return {
        ...state,
        deleteLoading: true,
        error: null,
      };

    case ANNOUNCEMENTS_ACTIONS.DELETE_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        error: null,
      };

    case ANNOUNCEMENTS_ACTIONS.DELETE_ANNOUNCEMENT_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        error: action.payload,
      };

    // Toggle Announcement
    case ANNOUNCEMENTS_ACTIONS.TOGGLE_ANNOUNCEMENT_REQUEST:
      return {
        ...state,
        toggleLoading: true,
        error: null,
      };

    case ANNOUNCEMENTS_ACTIONS.TOGGLE_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        toggleLoading: false,
        announcements: action.payload,
        error: null,
      };

    case ANNOUNCEMENTS_ACTIONS.TOGGLE_ANNOUNCEMENT_FAILURE:
      return {
        ...state,
        toggleLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default announcementsReducer;
